import { c as _c } from "react/compiler-runtime";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { Tooltip } from "react-tooltip";
import { formatNumberWithCommas } from "@/helpers/Helpers";
enum RoyaltiesType {
  NONE = "NONE",
  BELOW_THRESHOLD = "BELOW_THRESHOLD",
  ABOVE_THRESHOLD = "ABOVE_THRESHOLD",
}
const ROYALTIES_THRESHOLD = 0.069;
export default function UserPageStatsActivityWalletTableRowRoyalties(t0) {
  const $ = _c(22);
  const {
    royalties,
    transactionValue
  } = t0;
  let t1;
  if ($[0] !== royalties || $[1] !== transactionValue) {
    t1 = () => {
      if (!royalties) {
        return 0;
      }
      if (!transactionValue) {
        return 0;
      }
      return Math.round(royalties / transactionValue * 10000) / 10000;
    };
    $[0] = royalties;
    $[1] = transactionValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getRoyaltiesPercentage = t1;
  const percentage = getRoyaltiesPercentage();
  let t2;
  if ($[3] !== percentage || $[4] !== royalties || $[5] !== transactionValue) {
    t2 = () => {
      if (!royalties) {
        return RoyaltiesType.NONE;
      }
      if (!transactionValue) {
        return RoyaltiesType.NONE;
      }
      if (percentage < ROYALTIES_THRESHOLD) {
        return RoyaltiesType.BELOW_THRESHOLD;
      }
      return RoyaltiesType.ABOVE_THRESHOLD;
    };
    $[3] = percentage;
    $[4] = royalties;
    $[5] = transactionValue;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const getRoyaltiesType = t2;
  let t3;
  if ($[7] !== getRoyaltiesType || $[8] !== percentage || $[9] !== royalties) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const royaltiesType = getRoyaltiesType();
      let t4;
      if ($[11] !== percentage || $[12] !== royalties) {
        t4 = () => `Royalties: ${formatNumberWithCommas(+royalties.toFixed(7))}ETH (${formatNumberWithCommas(+(percentage * 100).toFixed(3))}%)`;
        $[11] = percentage;
        $[12] = royalties;
        $[13] = t4;
      } else {
        t4 = $[13];
      }
      const getContent = t4;
      switch (royaltiesType) {
        case RoyaltiesType.NONE:
          {
            t3 = null;
            break bb0;
          }
        case RoyaltiesType.BELOW_THRESHOLD:
          {
            let t5;
            if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
              t5 = <button type="button" className="tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-transparent tw-border-none tw-p-0 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400" data-tooltip-id="royalties-below-threshold" aria-label="Royalties information"><img src="/pepe-smile.png" className="tw-w-6 tw-h-6 sm:tw-w-5 sm:tw-h-5 tw-object-contain tw-flex-shrink-0" alt="pepe-smile" /></button>;
              $[14] = t5;
            } else {
              t5 = $[14];
            }
            let t6;
            if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
              t6 = {
                backgroundColor: "#1F2937",
                color: "white",
                padding: "4px 8px"
              };
              $[15] = t6;
            } else {
              t6 = $[15];
            }
            const t7 = getContent();
            let t8;
            if ($[16] !== t7) {
              t8 = <>{t5}<Tooltip id="royalties-below-threshold" style={t6}>{t7}</Tooltip></>;
              $[16] = t7;
              $[17] = t8;
            } else {
              t8 = $[17];
            }
            t3 = t8;
            break bb0;
          }
        case RoyaltiesType.ABOVE_THRESHOLD:
          {
            let t5;
            if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
              t5 = <button type="button" className="tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-transparent tw-border-none tw-p-0 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400" data-tooltip-id="royalties-above-threshold" aria-label="Royalties information"><img src="/pepe-xglasses.png" className="tw-w-6 tw-h-6 sm:tw-w-5 sm:tw-h-5 tw-object-contain tw-flex-shrink-0" alt="pepe-xglasses" /></button>;
              $[18] = t5;
            } else {
              t5 = $[18];
            }
            let t6;
            if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
              t6 = {
                backgroundColor: "#1F2937",
                color: "white",
                padding: "4px 8px"
              };
              $[19] = t6;
            } else {
              t6 = $[19];
            }
            const t7 = getContent();
            let t8;
            if ($[20] !== t7) {
              t8 = <>{t5}<Tooltip id="royalties-above-threshold" style={t6}>{t7}</Tooltip></>;
              $[20] = t7;
              $[21] = t8;
            } else {
              t8 = $[21];
            }
            t3 = t8;
            break bb0;
          }
        default:
          {
            assertUnreachable(royaltiesType);
            t3 = null;
            break bb0;
          }
      }
    }
    $[7] = getRoyaltiesType;
    $[8] = percentage;
    $[9] = royalties;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
}